import { useRef } from 'react';
import { Button } from '#components/atoms/buttons/Button.tsx';
import { ConfirmButtonGroup } from '#components/patterns/confirmations/confirm-button-group/ConfirmButtonGroup.tsx';
import { Modal, ModalBody, ModalFooter, ModalHeader } from '#components/patterns/modal/index.ts';
import { ALL_ROLES_FLAG } from '#screens/roles/detail/firewall-rule-form/FirewallRuleForm.queries.ts';
import type { CIDRFirewallRuleFormData } from '../cidr-firewall-rule-form-schema.ts';
import { CIDRFirewallRuleForm } from '../CIDRFirewallRuleForm.tsx';

type Props = {
  onSave: (newFw: CIDRFirewallRuleFormData) => void;
  onClose: () => void;
  /** Prefills the form, e.g. when duplicating an existing rule */
  defaultValues?: CIDRFirewallRuleFormData;
};

/**
 * Shows a form for adding a new firewall rule to a route
 */
export function AddCIDRFirewallRuleModal({ onSave, onClose, defaultValues }: Props) {
  const modalRef = useRef(null);

  const newFirewallRule =
    defaultValues ??
    ({
      localCIDR: 'Any',
      protocol: 'ANY',
      portRange: null,
      allowedRoleID: ALL_ROLES_FLAG,
      tags: [],
      description: '',
    } satisfies CIDRFirewallRuleFormData);

  return (
    <Modal ref={modalRef} isOpen={true} onClose={onClose}>
      <ModalHeader>Add route firewall rule</ModalHeader>
      <ModalBody>
        <CIDRFirewallRuleForm
          rule={newFirewallRule}
          onSave={(values) => {
            onSave(values);
          }}
        />
      </ModalBody>
      <ModalFooter>
        <ConfirmButtonGroup
          variant="right"
          primaryButton={
            <Button type="submit" form="cidr-firewall-rule-form">
              Add rule
            </Button>
          }
          secondaryButton={
            <Button variant="link" onClick={() => onClose()}>
              Cancel
            </Button>
          }
        />
      </ModalFooter>
    </Modal>
  );
}
